/**
 * Insights module - aggregates polling and BLS functionality
 * @module lib/insights
 */

const {
  resolveInsightsArticleId,
  buildInsightsActiveUrl,
  buildInsightsIframeUrl,
  buildPredictionIframeUrl,
  buildInsightsPublicUrl
} = require('./urls');
const { fetchActiveEmbedItem } = require('./query');
const { ensureInsightsIframeResizer, createInsightsIframeModule, createPredictionIframeModule } = require('./iframe');
const { readInsightsExposureSignal } = require('./exposure');
const { readStoredAnonId, storeAnonId, adoptAnonId } = require('./anonSync');
const { isSponsoredContent, readArticleTags, shouldSuppressInsightSurveyEmbed } = require('./pageContext');
const {
  ensureInsightsCompletionListener,
  isInsightsFrequencyCapped,
  listCompletedInsightsSurveyIds,
  markInsightsCompleted,
  isPredictionFrequencyCapped,
  markPredictionCompleted
} = require('./frequencyCap');
const { settleArticleEndSlot, waitForArticleEndSlot, extendArticleEndSlotDecision } = require('./articleEndSlot');
const {
  ensureStudyAssignments,
  clearStudyAssignments,
  studyTargeting,
  recordStudyPageview,
  recordStudySlotRender,
  recordStudySlotViewable,
  recordStudyVideoAd,
  deriveStudyGroup,
  resolveStudyGroup,
  waitForStudyGroup,
  studyImpressionSignal
} = require('./study');

module.exports = {
  resolveInsightsArticleId,
  buildInsightsActiveUrl,
  buildInsightsIframeUrl,
  buildPredictionIframeUrl,
  buildInsightsPublicUrl,
  fetchActiveEmbedItem,
  ensureInsightsIframeResizer,
  createInsightsIframeModule,
  createPredictionIframeModule,
  readInsightsExposureSignal,
  readStoredAnonId,
  storeAnonId,
  adoptAnonId,
  isSponsoredContent,
  readArticleTags,
  shouldSuppressInsightSurveyEmbed,
  ensureInsightsCompletionListener,
  isInsightsFrequencyCapped,
  listCompletedInsightsSurveyIds,
  markInsightsCompleted,
  isPredictionFrequencyCapped,
  markPredictionCompleted,
  settleArticleEndSlot,
  waitForArticleEndSlot,
  extendArticleEndSlotDecision,
  ensureStudyAssignments,
  clearStudyAssignments,
  studyTargeting,
  recordStudyPageview,
  recordStudySlotRender,
  recordStudySlotViewable,
  recordStudyVideoAd,
  deriveStudyGroup,
  resolveStudyGroup,
  waitForStudyGroup,
  studyImpressionSignal
};
